import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-5">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center">
                <i className="ri-book-read-line text-2xl text-primary-400"></i>
              </span>
              <span className="font-heading text-xl text-background-50">
                韩国漫画网
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              免费在线韩漫阅读平台，提供最新最全的韩国漫画资源。内容更新快，画质高清，随时随地畅享阅读乐趣。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">
              <a href="#footer-categories" className="hover:text-primary-400 transition-colors">热门分类</a>
            </h4>
            <ul className="space-y-2">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-background-100 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">
              <a href="#footer-more-categories" className="hover:text-primary-400 transition-colors">更多分类</a>
            </h4>
            <ul className="space-y-2">
              {categories.slice(5).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-background-100 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/category/recommended"
                  className="text-sm text-background-400 hover:text-background-100 transition-colors"
                >
                  热门推荐
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">
              <a href="#footer-about" className="hover:text-primary-400 transition-colors">关于我们</a>
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-background-100 transition-colors">
                  品牌介绍
                </Link>
              </li>
              <li>
                <a href="/about#contact" className="text-sm text-background-400 hover:text-background-100 transition-colors">
                  联系我们
                </a>
              </li>
              <li>
                <span className="text-sm text-background-500">service@koreanmanhwa.cn</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-500">
            &copy; {new Date().getFullYear()} 韩国漫画网. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-sm text-background-500 hover:text-background-300 transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="text-sm text-background-500 hover:text-background-300 transition-colors" rel="nofollow">服务条款</a>
            <a href="#" className="text-sm text-background-500 hover:text-background-300 transition-colors" rel="nofollow">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}